import { getGlobals, getAllResidenciesAndFellowshipsPaths, getResidenciesAndFellowshipItem } from "storyblok/api"
import Meta from "components/Meta"
import PageHeader from "components/DynamicComponent/atoms/PageHeader"
import DynamicComponent from "components/DynamicComponent"

export default function ResidenciesAndFellowships({ story }) {
  return (
    <>
      <Meta
        info={{
          title: `${story?.content?.name} | Sonoran Spine`,
          og_title: `${story?.content?.name} | Sonoran Spine`,
          twitter_title: `${story?.content?.name} | Sonoran Spine`,
        }}
      />
      <main>
        <PageHeader blok={{ heading: "Spine Surgery Fellowships & Residency Programs in Arizona" }} />
        {story?.content?.body?.map((blok) => (
          <DynamicComponent blok={blok} key={blok?._uid} />
        ))}
      </main>
    </>
  )
}

export async function getStaticProps({ params: { slug }, preview = null }) {
  const globals = await getGlobals()
  const story = await getResidenciesAndFellowshipItem(slug, preview)

  return {
    props: {
      story: story ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllResidenciesAndFellowshipsPaths(),
    fallback: false,
  }
}
